import { Application } from "@hotwired/stimulus";
import Rails from "@rails/ujs";
import "jquery";

// Utilities
import "../src/utilities/js/bulma_dropdown";
import "../src/utilities/js/bulma_pageloader";
import "../src/utilities/js/returning_parcels_block_toggler";
import "../src/utilities/js/bulma_divider";
import "../src/utilities/js/imask";
import "../src/utilities/js/file_input";
import "../src/utilities/js/timezone_field";
import "../src/utilities/js/select2";
import "../src/utilities/js/auto_focus";
import "../src/utilities/js/time_helper";
import "../src/utilities/js/flatpickr_date";
import "../src/utilities/js/flatpickr_date_unlim";
import "../src/utilities/js/flatpickr_time";
import "../src/utilities/js/flatpickr_reports_date";
import "../src/utilities/js/flatpickr_date_and_time";
import "../src/utilities/js/flatpickr_date_maxed";
import "../src/utilities/js/burger_dropdown";
import "../src/utilities/js/modal_trigger";
import "../src/utilities/js/tag_input";
import "../src/utilities/js/bulma_badge";
import "../src/utilities/js/quick_view";
import "../src/utilities/js/expandable_content";
import "../src/utilities/js/destination_notes";
import "../src/office/js/ui/comment_edit";
import "../src/office/js/ui/filter_form";
import "@fortawesome/fontawesome-free/js/all.js";
import "../src/office/js/ui/receiver_address_autocomplete";
import "../src/office/js/ui/sender_address_autocomplete";
import "../src/office/js/ui/additional_services_autocomplete";

// Stimulus controllers
import DestinationController from "../src/office/controllers/destination_controller";
import GroupRegistryController from "../src/office/controllers/group_registry_controller";
import LegacyDestinationController from "../src/office/controllers/legacy_destination_controller";
import LegacyWaybillController from "../src/office/controllers/legacy_waybill_controller";
import ParcelController from "../src/office/controllers/parcel_controller";
import UniversalController from "../src/office/controllers/universal_controller";

const application = Application.start();
application.register("destination", DestinationController);
application.register("group-registry", GroupRegistryController);
application.register("legacy-destination", LegacyDestinationController);
application.register("legacy-waybill", LegacyWaybillController);
application.register("parcel", ParcelController);
application.register("universal", UniversalController);

Rails.start();
